import {Authority, getBolb} from '../request'

const { get, post } = Authority
// 下载档案
export const downSlopeInfo = params => get('/road/slope-info/v1/export', { params })
// 路线列表
export const getRoadList = params => get('/road/roadRoute/v1/queryList', { params })
export const downloadSlopeInfo= params => getBolb('/road/slope-info/v1/downloadSlopeInfo', { params })
// 路线下拉列表
export const getRoadSelectList = params => get('/road/roadRoute/v1/querySelectList', { params })
// 路线下拉列表
// export const getRoadSelectList = params => get('/road/roadRoute/v1/querySelectList', { params })
// 路线新增
export const roadAdd = params => post('/road/roadRoute/v1/add', params)
// 路线更新
export const roadUpdate = params => post('/road/roadRoute/v1/update', params)
// 路线删除
export const roadDelete = params => post('/road/roadRoute/v1/delete', params)
//路线导入
export const importRoadUpload = params => post('/common/upload/v1/importRoad', params)

// 边坡动态添加
export const slopeStatusAdd = params => post('/road/status/v1/save', params)

// 路段列表
export const getRoadSectionList = params => get('/road/roadSection/v1/queryList', { params })
// 路段列表
export const getRoadSectionSelectList = params => get('/road/roadSection/v1/querySelectList', { params })
// 查询标段详情
export const getRoadSectionInfo = params => get('/road/roadSection/v1/queryById', { params })


// 路段新增
export const sectionAdd = params => post('/road/roadSection/v1/add', params)
// 路段更新
export const sectionUpdate = params => post('/road/roadSection/v1/update', params)
// 路段删除
export const deleteSection = params => post('/road/roadSection/v1/delete', params)

//边坡档案列表
export const getSlopeList = params => get('/road/slope-info/v1/queryList', { params })
//边坡档案下拉选择列表
export const getSlopeSelectList = params => get('/road/slope-info/v1/querySelectList', { params })
//边坡详情
export const getSlope = params => get('/road/slope-info/v1/queryOneById', { params })
// 边坡档案新增
export const slopeAdd = params => post('/road/slope-info/v1/add', params)
// 边坡档案参数导入
export const slopeAddMore = params => post('/road/slope-info/v1/import', params)
// 边坡档案更新
export const slopeUpdate = params => post('/road/slope-info/v1/update', params)
// 边坡档案删除
export const slopeDelete = params => post('/road/slope-info/v1/delete', params)

//边坡状态列表
export const getSlopeStatusList = params => get('/road/status/v1/queryList', { params })
export const downloadSlopeStatus= params => getBolb('/common/download/v1/exportSlopeStatus', { params })

//边坡状态时间线
export const getSlopeStatus = params => get('/road/slope-info/v1/queryStatusList', { params })


//地质灾害档案列表
export const getDamageList = params => get('/road/damage-info/v1/queryList', { params })
//地质灾害档案下拉选择列表
export const getDamageSelectList = params => get('/road/damage-info/v1/querySelectList', { params })
//地质灾害详情
export const getDamage = params => get('/road/damage-info/v1/queryOneById', { params })
// 地质灾害档案新增
export const damageAdd = params => post('/road/damage-info/v1/add', params)

export const damageAddMore = params => post('/road/damage-info/v1/import', params)
// 地质灾害档案更新
export const damageUpdate = params => post('/road/damage-info/v1/update', params)
// 地质灾害档案删除
export const damageDelete = params => post('/road/damage-info/v1/delete', params)


//区间详情
export const getRoadSectionInfo2= params => get('/road/roadSection/v1/getBaseInfo', { params })

//获取边坡编号
export const getSlopeNo= params => get('/road/uniqueNo/v1/generateSlopeNo', { params })



////////////////////档案导入
//区间档案导入
export const roadSectionImport = params => post('/common/upload/v1/importRoadSection', params)
//地质灾害档案导入
export const damageImport = params => post('/common/upload/v1/importDamageInfo', params)
//边坡档案导入
export const slopeImport = params => post('/common/upload/v1/importSlopeInfo', params)


////////////////////在建转运营

//获取在建边坡选择列表
export const getBuildSlope= params => get('/road/build-slope-info/v1/querySelectList', { params })
//获取可转在建列表
export const getBuildSlopeQueryAddList= params => get('/road/build-slope-info/v1/queryAddList', { params })
//获取在建边坡
export const getBuildSlopeById= params => get('/road/build-slope-info/v1/getById', { params })
//在建转运营
export const changeBuild = params => post('/road/build-slope-info/v1/changeBuild', params)
